module.exports = __webpack_public_path__ + "static/media/header_logo.bd9b84e5.svg";